import { el, setText } from './dom';

export type StatusTone = 'idle' | 'ok' | 'warn' | 'error';

export function makeBanner(badge: string, text: string): HTMLElement {
	return el('div', { className: 'kb-tools__banner' }, [
		el('span', { className: 'kb-tools__badge' }, [badge]),
		el('p', { className: 'kb-tools__banner-text' }, [text]),
	]);
}

export function makeChip(id: string): HTMLElement {
	return el('span', {
		className: 'kb-tools__chip kb-tools__chip--idle',
		id,
		role: 'status',
		'aria-live': 'polite',
	});
}

export function setChip(chip: HTMLElement, text: string, tone: StatusTone): void {
	chip.className = `kb-tools__chip kb-tools__chip--${tone}`;
	setText(chip, text);
}

export function makeFieldHead(label: HTMLElement, hint?: string): HTMLElement {
	const kids: Array<Node | string> = [label];
	if (hint) {
		kids.push(el('span', { className: 'kb-tools__hint' }, [hint]));
	}
	return el('div', { className: 'kb-tools__field-head' }, kids);
}

export function makePanel(title: string, body: HTMLElement, extraHead?: HTMLElement): HTMLElement {
	const headKids: Array<Node | string> = [el('h3', { className: 'kb-tools__panel-title' }, [title])];
	if (extraHead) {
		headKids.push(extraHead);
	}
	return el('section', { className: 'kb-tools__panel kb-tools__panel--result' }, [
		el('div', { className: 'kb-tools__panel-head' }, headKids),
		body,
	]);
}
